export default __webpack_public_path__ + "static/media/S3.de9337fc.jpg";